<template>
    <div class="flex flex-col gap-4">
        <step-sub-option
            v-for="subOption in topOptions"
            :key="subOption.name"
            :name="subOption.name"
            :selected-color="subOption.selectedColor"
            :has-error="hasSubOptionError(subOption)"
            :model-value="activeSubOptionName === subOption.name"
            :scroll-offset="180"
            @update:modelValue="handleUpdateSubOptionOpen(subOption.name, $event)"
        >
            <step-options-my-palette
                class="px-[40px] -mx-[64px] mb-4"
                :limit-by="subOption.name"
                :selected-color="subOption.selectedColor"
                @updateColorIsSelected="handleUpdateSelectedColor(subOption.name, $event)"
            />
            <master-palette
                class="mx-[-24px]"
                :limit-by="subOption.name"
                :selected-color="subOption.selectedColor"
                @updateColorIsSelected="handleUpdateSelectedColor(subOption.name, $event)"
            />
        </step-sub-option>
    </div>
</template>

<script>
    import allStores from '../stores/all';
    import StepSubOption from './StepSubOption.vue';
    import MasterPalette from './MasterPalette.vue';
    import StepOptionsMyPalette from './StepOptionsMyPalette.vue';

    export default {
        mixins: [allStores],

        components: {
            StepSubOption,
            MasterPalette,
            StepOptionsMyPalette,
        },

        data() {
            return {
                activeSubOptionName: null,
            };
        },

        props: {
            visiblePlacements: {
                type: Array,
                required: true,
            },

            hasColorErrorState: {
                type: Boolean,
                default: false,
            },
        },

        computed: {
            topOptions() {
                return this.customizerStore?.uiStepSubOptions?.top || [];
            },
        },

        methods: {
            handleUpdateSelectedColor(name, paletteValue) {
                this.customizerStore?.requestStepSubOptionColorChange(name, paletteValue);
            },

            hasSubOptionError(subOption) {
                return this.hasColorErrorState && !subOption?.selectedColor;
            },

            handleUpdateSubOptionOpen(name, isOpen) {
                this.activeSubOptionName = isOpen ? name : null;
            },
        },
    };
</script>
